<template>
  <el-col class="displayLayout" id="policyManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="保单状态">
          <el-select v-model="formInline.isInsuredStatusSeek" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="投保成功" value="1"></el-option>
            <el-option label="保单生效" value="7"></el-option>
            <el-option label="保单失效" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderId" placeholder="请输入您要查询的订单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">搜索</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="id"
                         label="订单号">
        </el-table-column>
        <el-table-column prop="accode"
                         width="210"
                         label="保单号">
        </el-table-column>
        <el-table-column prop="isInsuredStatus"
                         label="保单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.isInsuredStatus==1">投保成功</div>
            <div v-if="scope.row.isInsuredStatus==7">保单生效</div>
            <div v-if="scope.row.isInsuredStatus==9">保单失效</div>
          </template>
        </el-table-column>
        <el-table-column prop="payMoney"
                         label="保费">
        </el-table-column>
        <el-table-column prop="sellProductName"
                         width="150"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="policyHolderName"
                         width="150"
                         label="企业名称">
        </el-table-column>
        <el-table-column prop="months"
                         label="保险期限">
          <template slot-scope="scope">
            <div>12</div>
          </template>
        </el-table-column>
        <el-table-column prop="effectiveDate"
                         width="160"
                         label="开始生效时间">
        </el-table-column>
        <el-table-column prop="expireDate"
                         width="160"
                         label="结束生效时间">
        </el-table-column>
        <el-table-column width="130"
                         label="操作">
          <template slot-scope="scope">
            <el-button size="mini"><a style="color: #FFFFFF" :href="scope.row.beInsurePolicyUrl" target="_blank">下载电子保单</a></el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getPolicyList"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
  export default {
    name: "policyManagement",
    data() {
      return {
        loading:false,
        page: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        formInline: {
          isInsuredStatusSeek: '',
          orderId: ''
        }
      }
    },
    watch: {
      '$route' () {
        this.getPolicyList();
      }
    },
    methods: {
      handleSizeChange(val){
        this.page = 1;
        this.pageSize = val;
        this.getPolicyList();
      },
      onSelect(){
        this.page = 1;
        this.getPolicyList();
      },
      getPolicyList(){
        this.loading = true;
        this.axios.post('/management/mobileOrderInfoLog/getInsurancePolicy',null,{params:{
            _pageSize: this.pageSize,
            _current : this.page,
            insuranceIsGroup: this.$route.query.insuranceIsGroup,
            orderStatus: 2,
            accodeGroup: 1,
            isInsuredStatusSeek: this.formInline.isInsuredStatusSeek,
            orderId: this.formInline.orderId
          }}).then((response) => {
          let data = response.data;
          if (data.success) {
            this.tableData = data.datas;
            this.page = data.pagination.current;
            this.total = data.pagination.total;
            this.loading = false;
          } else {
            this.$message.error(data.msg);
          }

          let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
          $('.el-table__body-wrapper').css('height', height);
        })
      }
    },
    mounted() {
      if (!this.$$.checkLogin()) return false;

      this.getPolicyList();
    }
  }
</script>

<style scoped>
  @import "../../../../static/css/orderManagement.css";
  .cell .el-button{
    width: 90px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/policyManagement.vue